import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PermissionPayload, UserState } from "auth"
import { Noop, SimpleSelector } from "store"
import * as businessObjMapper from "models/mapper/businessObj"

const userState: UserState = {
	permissions: {
		businessObjList: [],
		menuList: [],
		user: null,
		userRoles: [],
		permissionList: [],
	},
	permsLoading: true,
}

export const UserSlice = createSlice({
	name: "user",
	initialState: userState,
	reducers: {
		setUserPermissions: (state, action: PayloadAction<PermissionPayload>) => {
			state.permsLoading = false
			state.permissions = {
				menuList: action.payload.menuList,
				// convert user permissions to business objects
				businessObjList: businessObjMapper.New().MapArray(action.payload.permissionList),
				user: action.payload.user,
				userRoles: action.payload.userRoles,
				permissionList: action.payload.permissionList,
			}
		},
		noop: Noop<void>(),
	},
	selectors: {
		selectUserPermissions: SimpleSelector<UserState, "permissions">("permissions"),
		selectLoading: SimpleSelector<UserState, "permsLoading">("permsLoading"),
		selectUserRoles: (s: UserState) => s.permissions.userRoles,
		selectUser: (s: UserState) => s.permissions.user,
		selectPermissionList: (s: UserState) => s.permissions.permissionList,
		selectBusinessObjList: (s: UserState) => s.permissions.businessObjList,
	},
})
